import React, { useState } from "react";
import { Alert, Box, Button, Card, CardContent, TextField, Typography } from "@mui/material";
import { errorText, p4u } from "./api";
import { createCredential, webAuthnSupported } from "./webauthn";

/**
 * Registers a passkey for the demo user in this browser, so this browser can act as
 * the approving device. Skip it if the user already has a passkey on the phone app.
 */
export default function Account({ config, username, onUsername }) {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState(null);

  const register = async () => {
    setBusy(true);
    setMessage(null);
    try {
      const options = await p4u().post("/registerUser", { username, clientId: config.clientId });
      if (options.status !== 201) throw new Error(errorText(options.data));
      const credential = await createCredential(options.data);
      const res = await p4u().post("/verify-registerUser-attestation", {
        username,
        clientId: config.clientId,
        credential,
        challenge: options.data.challenge,
      });
      if (res.status >= 300) throw new Error(errorText(res.data));
      setMessage({ severity: "success", text: "Passkey registered in this browser." });
    } catch (e) {
      setMessage({ severity: "error", text: e.message || "Failed" });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h6">Demo user</Typography>
        {!webAuthnSupported() && <Alert severity="error">This browser does not support passkeys (WebAuthn).</Alert>}
        <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
          <TextField size="small" label="Email" value={username} onChange={(e) => onUsername(e.target.value.trim())} sx={{ minWidth: 280 }} />
          <Button variant="outlined" onClick={register} disabled={busy || !username}>
            Register passkey in this browser
          </Button>
        </Box>
        {message && (
          <Alert severity={message.severity} sx={{ mt: 2 }}>
            {message.text}
          </Alert>
        )}
      </CardContent>
    </Card>
  );
}
